var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarNav3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V28C40 32.4183 36.4183 36 32 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 26.3334C14.558 26.3334 14.1341 26.1578 13.8215 25.8453C13.509 25.5327 13.3334 25.1088 13.3334 24.6668V11.3334C13.3334 10.8914 13.509 10.4675 13.8215 10.1549C14.1341 9.84235 14.558 9.66675 15 9.66675H21.6667C21.9305 9.66632 22.1918 9.71809 22.4355 9.81906C22.6792 9.92003 22.9005 10.0682 23.0867 10.2551L26.0767 13.2451C26.2641 13.4313 26.4127 13.6529 26.514 13.8969C26.6152 14.1409 26.6671 14.4026 26.6667 14.6668V24.6668C26.6667 25.1088 26.4911 25.5327 26.1786 25.8453C25.866 26.1578 25.4421 26.3334 25 26.3334H15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6666 9.66675V13.8334C21.6666 14.0544 21.7544 14.2664 21.9107 14.4227C22.067 14.579 22.2789 14.6667 22.5 14.6667H26.6666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNav3);
export default __webpack_public_path__ + "static/media/sidebar-nav-3.ba2faf96a4fae0700001db7dcf4fa756.svg";
export { ForwardRef as ReactComponent };